import { render, staticRenderFns } from "./foot2.vue?vue&type=template&id=ca4f2548&scoped=true"
import script from "./foot2.vue?vue&type=script&lang=js"
export * from "./foot2.vue?vue&type=script&lang=js"
import style0 from "./foot2.vue?vue&type=style&index=0&id=ca4f2548&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca4f2548",
  null
  
)

export default component.exports